import { ErrorBoundary } from '@/pages/corporate-documents/employee/corporate-documents.error';

export default ErrorBoundary;
